/**
 * A bizonylat TÍPUSÁNAK felirata — `docType` → magyar szó.
 *
 * Miért függvény, és nem a hívó oldalán összerakott kulcs: ugyanaz az érv,
 * mint a `statusLabel.ts`-nél. A `t()` hívások itt, LITERÁL kulccsal állnak,
 * így az i18n-kapu statikusan látja mind az ötöt; egy `t(\`document.docType.${x}\`)`
 * alakot a mérő nem venne észre, és a hiányzó fordítás nyers kulcsként
 * jelenne meg a képernyőn.
 *
 * A `switch` KIMERÍTŐ: a `DocType` a Prisma-séma enumja, és ha bővül, ez a
 * fájl nem fordul le. Egy `Record<DocType, string>` ugyanezt adná, de a
 * literál kulcsokat elrejtené a kapu elől.
 *
 * Ez a fájl a `packages/i18n` kanonikus forrásában él, és onnan másolódik
 * a szervizekbe (`python3 scripts/shared-sync.py`). Itt szerkeszd, ne a másolatot.
 */

import type { Translate } from './statusLabel';

export type DocType =
  | 'INBOUND_INVOICE'
  | 'OUTBOUND_INVOICE'
  | 'RECEIPT'
  | 'BANK_STATEMENT'
  | 'OTHER';

export function docTypeLabel(t: Translate, docType: DocType): string {
  switch (docType) {
    case 'INBOUND_INVOICE':
      return t('document.docType.INBOUND_INVOICE');

    case 'OUTBOUND_INVOICE':
      return t('document.docType.OUTBOUND_INVOICE');

    case 'RECEIPT':
      return t('document.docType.RECEIPT');

    case 'BANK_STATEMENT':
      return t('document.docType.BANK_STATEMENT');

    case 'OTHER':
      return t('document.docType.OTHER');

    default: {
      // Kimerítőség-ellenőrzés: ha a `DocType` bővül, ez a sor nem fordul le.
      const exhaustive: never = docType;

      // FUTÁSIDŐBEN VISZONT NEM DOBUNK. A `docType` a HÁLÓZATRÓL jön, a
      // szerver DTO-ja `string`, és a felület csak ráolvassa a típust — egy
      // bővült enum a backendből előbb érkezhet, mint az admin új verziója.
      // Dobva a kivétel a `QueueRow` MINDEN sorát elvinné render közben, és
      // ErrorBoundary híján fehér képernyő lenne belőle: a könyvelő az egész
      // munkalistát elveszítené egy ismeretlen bizonylattípus miatt.
      // Az `OTHER` nem kitalált jelentés — az enum saját gyűjtőértéke.
      void exhaustive;
      return t('document.docType.OTHER');
    }
  }
}
